import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from 'react-hot-toast';
import Login from "./Login";
import Dashboard from "./Dashboard";
import '@fortawesome/fontawesome-free/css/all.min.css';

const devToolsWarning = window.__REACT_DEVTOOLS_GLOBAL_HOOK__;
if (typeof devToolsWarning === 'object') {
    devToolsWarning.inject = function() {};
}

if (process.env.NODE_ENV === 'production') {
  console.warn = () => {};
}

// 保護路由的組件
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('token'); // 或其他驗證方法
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
  return (
  
    <Router
      future={{
        v7_startTransition: true
      }}
    >
      <Routes>
        {/* 根路徑重定向到登入頁 */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        
        {/* 登入頁 */}
        <Route path="/login" element={<Login />} />
        
        {/* 受保護的儀表板頁面 */}
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } 
        />
        
        {/* 捕捉所有未匹配路徑 */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
